import { Sprite, _decorator } from 'cc';
import LocalizedAsset from './LocalizedAsset';

const { ccclass, menu } = _decorator;

@ccclass('LocalizedSprite')
@menu('Internationalization/LocalizedSprite')
export default class LocalizedSprite extends LocalizedAsset<Sprite> {
    public reset() {
        this.target.spriteFrame = null;
    }

    protected onKeyChange(): void {
        this.target.spriteFrame = this.i18n.getSpriteFrame(this.key);
    }

    protected getTarget(): Sprite {
        return this.getComponent(Sprite);
    }
}
